import { LANGUAGE } from './Constants'
import { setItem, getItem } from './storage';


let refreshTokenTimeoutID = 0;

export let lang = "es";

export function setSelectedLanguage(lang) {
    setItem(LANGUAGE, lang);
}